export default __webpack_public_path__ + "static/media/Awards_Shapes-02.c5624cd1.png";